module.exports = __webpack_public_path__ + "static/img/main-con.ecbbfedb.png";